import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ETipoAcesso, NavigationMenu } from 'src/app/app-navigation';
import {
    AdmDashboardService,
    IFiltroDashboard
} from 'src/app/shared/api/licencas/adm-dashboard.service';
import { AdmLicencasService } from 'src/app/shared/api/licencas/adm-licencas.service';
import { DashboardService } from 'src/app/shared/api/licencas/dashboard.service';
import { ILicenca, LicencasService } from 'src/app/shared/api/licencas/licencas.service';
import { TabelaListagemComponent } from 'src/app/shared/components/tabela-listagem/tabela-listagem.component';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';
import { dateToEnglishDateString } from 'src/app/shared/functions/data-transform';
import { AuthService } from 'src/app/shared/services/auth.service';
import { licencasResource } from '../adm-licencas/licencas.resource';
import { LicencasFiltradasService } from './licencas-filtradas-service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    @ViewChild('listagemLicencas') listagemLicencas!: TabelaListagemComponent;

    apps_disponiveis: NavigationMenu[] = [];

    iniciadas = 0;
    concluidas = 0;
    naoIniciadas = 0;
    total = 0;

    loading = true;
    showTabelaLicencas = false;
    showLoaderLicencas = false;

    filtro?: IFiltroDashboard;

    licencasResource = licencasResource.colunas;
    actions = licencasResource.actions.filter((a) => a.mode == 'single');

    constructor(
        private authService: AuthService,
        private router: Router,
        private admDashboardService: AdmDashboardService,
        private dashboardService: DashboardService,
        private admLicencasService: AdmLicencasService,
        private licencasService: LicencasService,
        public licencasFiltradasService: LicencasFiltradasService
    ) {}

    ngOnInit(): void {
        const isAcessoPessoal = this.authService.getTipoAcesso() == ETipoAcesso.PESSOAL;
        if (isAcessoPessoal) this.navigateToTutorialPage();
        this.ajustarResourceLicencas();
    }

    private navigateToTutorialPage() {
        this.router.navigate([
            ConstantsRotasDoSistema.DEFAULT_PATH + ConstantsRotasDoSistema.APRESENTACAO
        ]);
    }

    changeFiltros(filtro: any) {
        const cliente = filtro?.filtroCliente?.cliente;
        const equipe = filtro?.filtroEquipe?.equipe;
        const iniciadoDe = filtro?.filtroIniciado?.iniciadoDe;
        const iniciadoAte = filtro?.filtroIniciado?.iniciadoAte;
        const concluidoDe = filtro?.filtroConcluido?.concluidoDe;
        const concluidoAte = filtro?.filtroConcluido?.concluidoAte;

        this.listarDashboard(cliente, equipe, iniciadoDe, iniciadoAte, concluidoDe, concluidoAte);
    }

    listarDashboard(
        cliente: any = null,
        equipe: any = null,
        iniciadoDe = null,
        iniciadoAte = null,
        concluidoDe = null,
        concluidoAte = null
    ) {
        const params: IFiltroDashboard = {};
        if (cliente) params.dono = cliente.uuid;
        if (equipe) params.equipe = equipe.uuid;
        if (iniciadoDe) params.data_inicio_de = dateToEnglishDateString(iniciadoDe);
        if (iniciadoAte) params.data_inicio_ate = dateToEnglishDateString(iniciadoAte);
        if (concluidoDe) params.data_fim_de = dateToEnglishDateString(concluidoDe);
        if (concluidoAte) params.data_fim_ate = dateToEnglishDateString(concluidoAte);

        this.loading = true;
        this.filtro = params;
        this.filtro.em_uso = true;

        this.getService()
            .getDashboard(params)
            .subscribe({
                next: (response) => {
                    this.showTabelaLicencas = false;
                    this.iniciadas = response.iniciadas;
                    this.concluidas = response.concluidas;
                    this.naoIniciadas = response.nao_iniciadas;
                    this.total = response.total;
                    this.loading = false;
                }
            });
    }

    private getService(): AdmDashboardService | DashboardService {
        const tipoAcesso = this.authService.getTipoAcesso();
        if (tipoAcesso == ETipoAcesso.ADMINISTRADOR) {
            return this.admDashboardService;
        }
        return this.dashboardService;
    }

    onClickCardQuantidade(tipo: 'iniciadas' | 'concluidas' | 'nao-iniciadas' | 'total') {
        this.listarLicencas(tipo);
    }

    private getListarlicencasService(filtro: any) {
        const tipoAcesso = this.authService.getTipoAcesso();
        if (tipoAcesso == ETipoAcesso.ADMINISTRADOR) {
            return this.admLicencasService.get(filtro);
        }
        return this.licencasService.get(filtro);
    }

    private listarLicencas(tipo: 'iniciadas' | 'concluidas' | 'nao-iniciadas' | 'total') {
        const filtro: any = { ...this.filtro };
        filtro.tamanho = 99999;

        this.showLoaderLicencas = true;
        this.getListarlicencasService(filtro).subscribe({
            next: (response) => {
                let resultados: ILicenca[] = [];

                if (tipo == 'iniciadas') {
                    resultados = response.resultados.filter(
                        (licenca) => licenca.data_inicio != null
                    );
                } else if (tipo == 'concluidas') {
                    resultados = response.resultados.filter((licenca) => licenca.data_fim != null);
                } else if (tipo == 'nao-iniciadas') {
                    resultados = response.resultados.filter(
                        (licenca) => licenca.data_inicio == null
                    );
                } else if (tipo == 'total') {
                    resultados = response.resultados;
                }

                this.licencasFiltradasService.setLicencas(resultados);
                this.showTabelaLicencas = true;
                this.showLoaderLicencas = false;
                this.listagemLicencas?.listarEntidades();
            }
        });
    }

    private ajustarResourceLicencas() {
        const isAcessoCliente = this.authService.getTipoAcesso() == ETipoAcesso.CLIENTE;

        if(!isAcessoCliente) return;

        this.licencasResource = this.licencasResource.filter((coluna) => coluna.field != 'dono.nome_fantasia');
    }
                    
}
